import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/styles'
import { ValidationContext } from './validationContext'
import { ErrorValidationIcon } from './errorValidationIcon'
import { format } from 'utils/stringUtilities'
import { LoadingIndicator } from 'components/loading'
import { isNotNull } from 'utils/isNotNull'
import { styles } from './validator.css'

class Validator extends React.PureComponent {
  constructor (props) {
    super(props)

    const errorMessage = this.validate()

    this.state = {
      fetching: false,
      error: null,
      serverValidationResult: { validatedValue: props.value },
      errorMessage
    }
  }
  componentDidMount() {
    const { errorMessage } = this.state
    if (this.shouldUpdateValidationContext(this.context.errors, errorMessage)) { 
      this.context.onValidate({ field: this.props.name, error: errorMessage }, this.props.disabled)
    }
  }
  componentDidUpdate (prevProps, prevState) {
    const errorMessage = this.validate()
    if (!this.state.errorMessage || !errorMessage || this.state.errorMessage[0] !== errorMessage[0]) {
      this.setState({ errorMessage })
    }

    if (this.shouldUpdateValidationContext(this.context.errors, errorMessage)) { 
      this.context.onValidate({ field: this.props.name, error: errorMessage }, this.props.disabled)
    }
    
    if (!errorMessage) {

      const { serverValidation, value } = this.props
      if (typeof serverValidation === 'function') {
        if (!this.state.fetching) {
          const { serverValidationResult } = this.state
          if (serverValidationResult === null || serverValidationResult.validatedValue !== value) {
            this.setState({ fetching: true, error: null }, () => {
              serverValidation(value)
                .then(result => this.setState({
                  fetching: false, 
                  serverValidationResult: {
                    validatedValue: value,
                    result
                  }
                }))
                .catch(error => this.setState({
                  fetching: false, 
                  serverValidationResult: { validatedValue: value },
                  error
                }))
            })
          }
        }
      }
    }
  }
  validate = () => {
    const { required, value, regex, maxLength, min, max, serverValidation, onValidate, name } = this.props
    if (required) {
      if (typeof value !== 'number' && !value) {
        return ['validations.required']
      }
      if (Array.isArray(value) && value.length === 0) {
        return ['validations.arrayRequired']
      }
    }
    if (regex && typeof value === 'string') {
      if (!new RegExp(regex).test(value)) {
        return ['validations.invalidFormat']
      }
    }
    if (maxLength && typeof value === 'string') {
      if (value.length > maxLength) {
        return ['validations.maxLengthExceeded', maxLength]
      }
    }
    if (typeof value === 'number') {
      if (isNotNull(min) && value < min) {
        return ['validations.lessThanMinValue', min]
      }
      if (isNotNull(max) && value > max) {
        return ['validations.maxValueExceeded', max]
      }
    }
    if (typeof serverValidation === 'function') {
      if (!this.state.fetching) {
        const { serverValidationResult, error } = this.state

        if (error) { return ['validations.errorOccurred', error] }

        if (serverValidationResult &&
            serverValidationResult.validatedValue === value &&
            serverValidationResult.result &&
            serverValidationResult.result.validationError) {
          return serverValidationResult.result.validationError
        }
      }
    }
    if (typeof onValidate === 'function') {
      return onValidate({ name, value })
    }
  }
  getValidationResultIcon = ({ errorMessage }) => {
    const { classes, name } = this.props
    const iconProps = { style: { fontSize: 16 } }
    if (this.state.fetching) {
      return (
        <span className={`${classes.icon} ${classes.loading}`}>
          <LoadingIndicator size={16} outerStyle={{ marginRight: 'inherit' }} />
        </span>
      )
    }
    if (!errorMessage) {
      return null;
    }
    
    const params = errorMessage.length > 0 ? errorMessage.slice(1) : [name]
    return <ErrorValidationIcon title={format(this.context.localize(errorMessage[0]), params)} iconProps={iconProps} />
  }
  shouldUpdateValidationContext = (errors, errorMessage) => {
    const error = errors.find(e => e.field === this.props.name)
    if (!error) {
      if (errorMessage) { return true }
    } else {
      if (errorMessage) {
        if (errorMessage[0] !== error.error[0]) { return true }
      } else {
        return true
      }
    }
    return false
  }
  render () {
    const { disabled, classes, children, style } = this.props
    if (disabled) { return children }

    const { errorMessage } = this.state

    const css = errorMessage ? classes.hasError : ''
    return (
      <div className={`${classes.root} ${css}`} style={style}>
        {children}
        {this.getValidationResultIcon({ errorMessage })}
      </div>
    )
  }
}
Validator.contextType = ValidationContext
const StyledValidator = withStyles(styles)(Validator)

Validator.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  regex: PropTypes.object,
  onValidate: PropTypes.func,
  maxLength: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  serverValidation: PropTypes.func,
  children: PropTypes.node
}

export {
  StyledValidator
}